import React from "react";
import { GoBackButton } from "../../login/components/GoBackButton";
import { Box, Text, Flex, Icon, Button } from "@chakra-ui/react";
import { MdDownload } from "react-icons/md";

const UserProfileTab = ({ name = "", phone = "" }) => {
  const TRIANGLE_COLORS = ["#1E40AF", "#6438C275"];
  return (
    <Box
      position="relative"
      d={"flex"}
      flexDirection={["column", "row"]}
      gap="25px"
      overflow={"hidden"}
      alignItems={"center"}
      justifyContent={"space-between"}
      bg={
        "linear-gradient(to right, white 20%, rgb(136, 175, 218) 50%, white 95%)"
      }
      borderRadius="10px"
      py="28px"
    >
      <Box px="10px" pl={"1.5em"} pt="10px">
        <Box>
          <Text fontSize={"32px"} fontWeight="bold" color="primary.500">
            {`Hello, ${name}`}
          </Text>

          <Text mt={".1em"} fontSize={"16px"} fontWeight={500} color="gray.700">
            {phone}
          </Text>
        </Box>
      </Box>
      <Box
        bg="white"
        boxShadow="md"
        width="fit-content"
        maxW="none"
        marginBlock={"auto"}
        display="inline-flex"
        alignItems="flex-start"
        alignSelf="flex-start"
        gap="8px"
        borderRadius="10px"
        position={"relative"}
        p="10px"
        mx="10px"
      >
        {/* Icon */}
        <Button
          sx={{
            p: 3,
            bg: "#EC7E0F17",
            _hover: { bg: "orange.400" },
            borderRadius: "10px",
            h: "100%",
          }}
        >
          <Icon as={MdDownload} color="primary.500" boxSize="20px" mt="2px" />
        </Button>
        <Box w="fit-content">
          <Text as={"span"} color="primary.500" fontWeight={"bold"}>
            Get the Mobile App
          </Text>
          <Text
            display={["none", "block"]}
            fontSize={"14px"}
            w={"200px"}
            color={"gray.default"}
          >
            Invite friends to use ovend and get rewarded
          </Text>
        </Box>
        {/* Coming Soon */}
        <Text
          sx={{
            position: "absolute",
            right: "8px",
            top: "-15px",
            color: "white",
            bg: "#EC7E0F",
            px: "8px",
            py: "2px",
            zIndex: 1,
            borderRadius: "20px",
          }}
        >
          Coming Soon
        </Text>
      </Box>

      <Flex
        position="absolute"
        left={0}
        right={0}
        bottom="-18px"
        h="44px"
        gap={"0"}
        w="200px"
        px="8px"
        align="flex-start"
      >
        {Array.from({ length: 6 }).map((_, i) => (
          <Box
            key={i}
            flex="1"
            h="44px"
            w="5px"
            bg={TRIANGLE_COLORS[i % TRIANGLE_COLORS.length]}
            clipPath="polygon(50% 0%, 0% 100%,  100% 100%)"
            ml={i === 0 ? "0" : "-30px"}
          />
        ))}
      </Flex>
    </Box>
  );
};

export default UserProfileTab;
